
(function(){
  /* Writing an attribute always produces a MutationObserver record, even when
     the value is unchanged. Since run() is itself driven by that observer,
     any unguarded write is an infinite loop. Every repeatable write goes
     through setAttr. */
  function setAttr(el,name,val){
    try{ if(el.getAttribute(name)!==val) el.setAttribute(name,val); }catch(e){}
  }
  var map={'44175513682099':'6a5bddfa2a0ec97b717092ee','44210210341043':'6a5be1a62a0ec97b71709a98','44217466847411':'6a5be24147aad7d1f9d06223','44217554993331':'6a5be2d247aad7d1f9d0634f','44666224705715':'6a5be35f2a0ec97b71709f81','44697242665139':'6a6a5500e0abb046020db3c9'};
  function fixLinks(){
    try{
      document.querySelectorAll('a[data-original-href*="servicify"],a[href*="servicify"]').forEach(function(a){
        var u=a.getAttribute('data-original-href')||a.getAttribute('href')||'';
        var m=u.match(/servicify-variant=(\d+)/); if(!m) return;
        var svc=map[m[1]]; if(!svc) return;
        var link='https://app.cowlendar.com/cal/'+svc+'/'+m[1];
        setAttr(a,'data-original-href',link); setAttr(a,'href',link);
        setAttr(a,'data-cowlendar-btn',svc+'-'+m[1]);
        setAttr(a,'data-cldr-remapped','1');
      });
    }catch(e){}
  }
  /* The pre-booking weight gate exists for AIRCRAFT. The Redbird MCX has no
     weight limit, so a simulator booking must never be shown the aircraft
     weight table. Marking its buttons cleared makes the gate skip them. */
  function clearSimGate(){
    try{
      if((location.pathname||'').indexOf('discovery-flight-using-a-redbird-full-motion-flight-simulator')===-1) return;
      document.querySelectorAll('.cowlendar-btn,[data-cowlendar-btn],[class*="cowlendar-btn"],a[href*="cow_sid"],a[href*="6a6a5500e0abb046020db3c9"]').forEach(function(b){
        setAttr(b,'data-lafs-cleared','1');
      });
    }catch(e){}
  }
  /* The discovery-flight booking confirmation tells customers to meet at the
     other school's suite number at this address. LA Flight School is Suite
     108A. Customers who have already paid are being sent to the wrong door,
     so this is corrected in place until that page is rebuilt in Liquid. Text
     nodes and common attributes, same approach as the phone fix below. */
  function fixAddress(){
    try{
      var re=/Suite\s*D-?3\b/i;
      if(!re.test((document.body||document.documentElement).textContent||'')) return;
      var w=document.createTreeWalker(document.body||document.documentElement, NodeFilter.SHOW_TEXT, null);
      var hits=[], n;
      while(n=w.nextNode()){ if(re.test(n.nodeValue)) hits.push(n); }
      hits.forEach(function(t){ t.nodeValue=t.nodeValue.replace(/Suite\s*D-?3\b/gi,'Suite 108A'); });
      document.querySelectorAll('[aria-label],[title],[alt]').forEach(function(el){
        ['aria-label','title','alt'].forEach(function(an){
          var v=el.getAttribute(an);
          if(v && re.test(v)) setAttr(el,an,v.replace(/Suite\s*D-?3\b/gi,'Suite 108A'));
        });
      });
    }catch(e){}
  }
  function fixPhones(){
    try{
      var re=/\(?818\)?[\s.\-]?514[\s.\-]?2233/;
      if(!/514/.test((document.body||document.documentElement).textContent||'') && !document.querySelector('[aria-label*="514"],[title*="514"],[gp-data*="514"]')) return;
      var walker=document.createTreeWalker(document.body||document.documentElement, NodeFilter.SHOW_TEXT, null);
      var nodes=[], n;
      while(n=walker.nextNode()){ if(re.test(n.nodeValue)){ nodes.push(n); } }
      nodes.forEach(function(t){ t.nodeValue=t.nodeValue.replace(/(\(?818\)?[\s.\-]?)514([\s.\-]?)2233/g,'$1290$28249'); });
      document.querySelectorAll('[aria-label],[title],[gp-data]').forEach(function(el){
        ['aria-label','title','gp-data'].forEach(function(an){
          var v=el.getAttribute(an);
          if(v && /5142233|514[\s.\-]?2233/.test(v)){
            el.setAttribute(an, v.replace(/8182908249/g,'8182908249').replace(/(\(?818\)?[\s.\-]?)514([\s.\-]?)2233/g,'$1290$28249'));
          }
        });
      });
    }catch(e){}
  }

  /* ------------------------------------------------------------------
     The Discovery Flight comparison page hard-codes variant IDs in an
     inline script. When each flight was split into one product per
     duration, the old 90 min / 120 min / Add-a-guest variants were
     deleted, so toggling those options handed Cowlendar a variant that
     no longer exists -> "Cart Error (Cannot find variant)".
     ------------------------------------------------------------------ */
  var DEAD={
    '45723008598195':['6a6c2d52197be45d26bd45b6','45747090489523'],
    '45723008630963':['6a6c2dae197be45d26bd46d4','45747091013811'],
    '45723008663731':['6a6c2e03197be45d26bd474b','45747091112115'],
    '45723008696499':['6a6c2e4be014d56e937bac76','45747091243187'],
    '45723009024179':['6a6c2f82e014d56e937bafd7','45747091570867'],
    '45723009056947':['6a6c2fcee014d56e937bb08d','45747091800243'],
    '45723009089715':['6a6c3012197be45d26bd4ca2','45747092029619'],
    '45723009122483':['6a6c3060e014d56e937bb19b','45747094618291'],
    '45723009155251':['6a6c30aa197be45d26bd4e70','45747094847667'],
    '45723008762035':['6a6c2e99197be45d26bd48dd','45747091341491'],
    '45723008794803':['6a6c2f36197be45d26bd4a52','45747091472563']
  };
  var DEADIDS=Object.keys(DEAD);
  /* Each retired variant belongs to a NEW product with its OWN Cowlendar
     service, so the service id in the link has to move with it. The page
     writes them as "<service>/<variant>" and "<service>-<variant>". */
  var PAIR=new RegExp('([a-f0-9]{20,26})([/-])('+DEADIDS.join('|')+')','g');
  var BARE=new RegExp('('+DEADIDS.join('|')+')','g');
  function swap(v){
    v=v.replace(PAIR,function(m,svc,sep,dead){ return DEAD[dead][0]+sep+DEAD[dead][1]; });
    return v.replace(BARE,function(dead){ return DEAD[dead][1]; });
  }
  function fixDeadVariants(){
    try{
      document.querySelectorAll('[href],[data-cowlendar-btn],[data-variant],[data-variant-id],[data-original-href]').forEach(function(el){
        for(var i=0;i<el.attributes.length;i++){
          var a=el.attributes[i], v=a.value;
          if(!v) continue;
          var nv=swap(v);
          if(nv!==v) setAttr(el,a.name,nv);
        }
      });
    }catch(e){}
  }

  /* "Book This Flight" buttons inside the product description pointed at
     /cart/<variant>:1 - a raw cart permalink that skipped both the calendar
     and the weight gate. Route them through the page's own Book now button.

     The match is on the PATH, not the start of the href, because the same
     permalink is also written absolutely ("https://la-flightschool.com/cart/
     <variant>:1"). The old ^="/cart/" selector missed every absolute one,
     which is how the simulator hub's six Book buttons were still adding to
     the cart directly and being bounced to the product page.

     A simulator permalink is routed to the SIMULATOR calendar specifically.
     bookBtn() returns the first Cowlendar button on the page, and on any page
     carrying the book-or-gift block that is a discovery-flight button - so
     the generic path would have opened the wrong calendar. */
  var SIM_VAR='44697242665139';
  function bookBtn(){
    return document.querySelector('form[action$="/cart/add"] .cowlendar-btn')
        || document.querySelector('.cowlendar-btn')
        || document.querySelector('[data-cowlendar-btn]');
  }
  function fixDescriptionButtons(){
    try{
      document.querySelectorAll('a[href*="/cart/"]').forEach(function(a){
        if(a.getAttribute('data-lafs-tocal')==='1') return;
        var m=(a.getAttribute('href')||'').match(/\/cart\/(\d+):\d+/);
        if(!m) return;
        a.setAttribute('data-lafs-tocal','1');
        var isSim=(m[1]===SIM_VAR);
        if(isSim) setAttr(a,'data-lafs-cleared','1');
        a.addEventListener('click',function(e){
          if(isSim){
            e.preventDefault(); e.stopPropagation();
            openSimCal();
            return;
          }
          var b=bookBtn(); if(!b) return;
          e.preventDefault(); e.stopPropagation();
          b.click();
        },true);
      });
    }catch(e){}
  }

  /* ==================================================================
     SIMULATOR "BOOK" TRIGGERS
     Every "book" word attached to the Redbird simulator opens the
     simulator calendar, sitewide. Two cases:
       1. On the simulator product page: every link or button in the page
          body whose label contains the word "book" opens the calendar.
          Site chrome - header, nav, footer, cart drawer - is left alone,
          so the global "Book a Discovery Flight" still goes to the hub.
       2. Everywhere else: a link that already points at the simulator
          product AND says "book" opens the calendar instead of bouncing
          the customer to the product page first.
     The match is word-bounded, so "Facebook" is never caught. Anything
     that is already a Cowlendar button is left as it is - it only gets
     marked cleared so the aircraft weight table never appears for the
     Redbird, which has no weight limit.
     ================================================================== */
  var SIM_HANDLE='discovery-flight-using-a-redbird-full-motion-flight-simulator';
  var SIM_PAGE='full-motion-redbird-mcx-faa-approved-flight-simulator-at-van-nuys-airport';
  var SIM_SVC='6a6a5500e0abb046020db3c9';
  var BOOKWORD=/\bbook(s|ed|ing|able)?\b/i;
  var CHROME='header,nav,footer,[role="banner"],[role="navigation"],[role="contentinfo"],.header,.site-header,.site-footer,.announcement-bar,.cart-drawer,.mini-cart,.drawer,.menu-drawer';
  var SKIP='summary,.faq-q,[aria-expanded],[data-accordion],[aria-controls]';

  function simNative(){
    var list=document.querySelectorAll('[data-cowlendar-btn*="'+SIM_SVC+'"],a[href*="'+SIM_SVC+'"]');
    for(var i=0;i<list.length;i++){
      if(list[i].getAttribute('data-lafs-simbook')==='1') continue;
      if(list[i].offsetParent===null) continue;
      return list[i];
    }
    return null;
  }
  function openSimCal(){
    /* Always go through Cowlendar's own button so the customer gets the
       app's real modal, wired to the real cart. If this page has no
       simulator button, hand off to the SIMULATOR HUB PAGE and open it
       there - one hop, but it is the flow Cowlendar actually supports.

       This used to hand off to /products/<handle>, which is the one place
       a customer must never be sent. The hub carries six native simulator
       Cowlendar anchors, so autoOpenSimCal picks one up on arrival and the
       calendar opens without the product page ever being rendered. */
    var n=simNative();
    if(n){ n.setAttribute('data-lafs-cleared','1'); n.click(); return; }
    window.location.assign('/pages/'+SIM_PAGE+'?lafsbook=1');
  }
  function autoOpenSimCal(){
    if((location.search||'').indexOf('lafsbook=1')===-1) return;
    var tries=0;
    var t=setInterval(function(){
      var n=simNative();
      if(n){
        clearInterval(t);
        n.setAttribute('data-lafs-cleared','1');
        setTimeout(function(){ n.click(); },250);
      }
      if(++tries>40) clearInterval(t);
    },250);
  }
  function wireSimEl(el){
    el.setAttribute('data-lafs-simbook','1');
    el.setAttribute('data-lafs-cleared','1');
    try{ el.style.cursor='pointer'; }catch(e){}
    el.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      openSimCal();
    },true);
  }
  function wireSimBook(){
    try{
      var onSim=(location.pathname||'').indexOf(SIM_HANDLE)!==-1;
      document.querySelectorAll('a,button,[role="button"]').forEach(function(el){
        if(el.getAttribute('data-lafs-simbook')==='1') return;
        var href=el.getAttribute('href')||'';
        var cow=el.getAttribute('data-cowlendar-btn')||'';
        if(cow.indexOf(SIM_SVC)!==-1 || href.indexOf(SIM_SVC)!==-1){
          setAttr(el,'data-lafs-cleared','1');
          return;
        }
        if(cow || /cowlendar\.com/.test(href)) return;
        var txt=(el.textContent||'').trim();
        if(!txt || txt.length>80) return;
        if(!BOOKWORD.test(txt)) return;
        if(el.closest && el.closest(SKIP)) return;
        if(href.indexOf(SIM_HANDLE)===-1){
          if(!onSim) return;
          if(el.closest && el.closest(CHROME)) return;
          if(/^mailto:|^tel:|\/cart|\/checkout|\/account/.test(href)) return;
        }
        wireSimEl(el);
      });
    }catch(e){}
  }

  /* Cowlendar ends a booking on a "Booking added to cart" panel whose only
     button is "Book another session". While its modal is open we sample the
     cart and send the customer to checkout the moment a line appears. */
  var cowSeen=0, cowBase=null, cowDone=false;
  function cowOpen(){
    var f=document.querySelector('iframe.cowlendar-iframe') || document.querySelector('iframe[src*="cowlendar.com"]');
    if(!f || f.offsetParent===null) return false;
    var r=f.getBoundingClientRect();
    return r.width>200 && r.height>200;
  }
  function cowTick(){
    try{
      if(cowDone) return;
      if(cowOpen()) cowSeen=Date.now();
      if(!cowSeen) return;
      if(Date.now()-cowSeen>25000){ cowSeen=0; cowBase=null; return; }
      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
        if(cowBase===null){ cowBase=c.item_count; return; }
        if(c.item_count>cowBase){
          cowDone=true;
          window.location.assign('/checkout');
        }
      }).catch(function(){});
    }catch(e){}
  }
  setInterval(cowTick,1000);

  function run(){ fixDeadVariants(); fixLinks(); clearSimGate(); fixAddress(); fixPhones(); fixDescriptionButtons(); wireSimBook(); }
  if(document.readyState!=='loading')run();
  document.addEventListener('DOMContentLoaded',run);
  /* 2026-10-31 (v95 speed): was run() every 400 ms, 31 times (about 12 s of full-page scans). The MutationObserver below already repairs late changes, so four timed passes cover slow app widgets. */
  [400,1200,2500,5000].forEach(function(t){ setTimeout(run,t); });
  /* Attribute repairs run SYNCHRONOUSLY on just the element that changed.
     The comparison page rewrites a card's href the instant a duration is
     toggled; deferring the repair even one frame leaves a window where the
     customer can click a variant that no longer exists, which is the
     "Cannot find variant" cart error all over again. This is cheap because
     it touches one element, and it cannot retrigger itself because every
     write goes through setAttr. Structural changes are rarer and can
     afford the debounced full pass. setTimeout, not requestAnimationFrame,
     so it still runs in a background tab. */
  function repairEl(el){
    if(!el || el.nodeType!==1 || !el.attributes) return;
    for(var i=0;i<el.attributes.length;i++){
      var a=el.attributes[i], v=a.value;
      if(!v) continue;
      var nv=swap(v);
      if(nv!==v) setAttr(el,a.name,nv);
    }
  }
  var pending=false;
  function schedule(){
    if(pending) return;
    pending=true;
    setTimeout(function(){ pending=false; run(); },150);
  }
  function onMutations(recs){
    try{
      var structural=false;
      for(var i=0;i<recs.length;i++){
        var r=recs[i];
        if(r.type==='attributes') repairEl(r.target);
        else if(r.addedNodes && r.addedNodes.length) structural=true;
      }
      if(structural) schedule();
    }catch(e){}
  }
  try{new MutationObserver(onMutations).observe(document.documentElement,{childList:true,subtree:true,attributes:true});}catch(e){}
  autoOpenSimCal();
})();
